<template>
  <div class="delete">
    <a-modal
      v-model="visible"
      centered
      :closable="false"
      :maskClosable="false"
      :footer="null"
      :bodyStyle="bodyStyle"
      :width="436"
      @cancel="doCancle"
    >
      <div class="delete-title">
        <sass-icon type="hi-yiwen" style="font-size: 20px;" class="title-icon"/>
        <span class="title-font">{{ tipInfo.title }}</span>
      </div>
      <div class="tip-content">{{ tipInfo.detail }}</div>
      <div class="delete-footer">
        <slot name="custom-footer">
          <a-button class="footer-comfirm" @click="doComfirm">确认</a-button>
          <a-button class="footer-cancle" @click="doCancle">取消</a-button>
        </slot>
      </div>
    </a-modal>
  </div>
</template>
<script>
/**
 * 共用提示弹窗使用说明：
 * 传入参数：
 * isVisible: 控制弹窗显隐，值为true/false
 * info: 传入数据对象，title：弹窗名称，detail：弹窗说明， type：single单条，batch批量
 * close: 返回方法，关闭弹窗，返回false则点击取消，返回对象obj点击确定，obj.type控制单条还是批量
 */
import CommonIcon from '@/components/common-icon'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    }
  },
  components: {
    CommonIcon
  },
  computed: {
    visible: {
      get () {
        return this.isVisible
      },
      set () {}
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.tipInfo = this.info ? this.info : this.tipInfo
      }
    }
  },
  data () {
    return {
      tipInfo: { // 使用弹窗传参
        title: '',
        detail: ''
      },
      bodyStyle: {
        paddingTop: '24px!important',
        paddingBottom: '24px!important',
        paddingLeft: '24px!important',
        paddingRight: '24px!important',
        height: '174px!important'
      }
    }
  },
  methods: {
    // 点击确认
    doComfirm () {
      const obj = {}
      obj.type = this.tipInfo.type
      if (this.tipInfo.row) obj.row = this.tipInfo.row
      this.$emit('close', obj)
    },
    // 点击取消
    doCancle () {
      // console.log('点击取消')
      this.$emit('close', false)
    }
  }
}
</script>
<style lang='less' scoped>
.delete-title {
  display: flex;
  position: relative;
  height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 24px;
  flex-direction: row;
  align-items: center;
  .title-icon {
    color: #faad14;
  }
  .title-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 56px;
    // text-align: center;
    line-height: 56px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    // border: 1px solid red;
  }
  .title-font {
    margin-left: 16px;
    font-family: 'PingFangSC-Medium';
    font-size: 16px;
    color: rgba(51, 51, 51, .85);
  }
}
.tip-content {
  margin-top: 13px;
  padding-left: 36px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, .85);
  .title-icon {
    margin: 0 16px 0 24px;
    vertical-align: middle;
    color: #faad14;
  }
}
.delete-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 56px;
  text-align: right;
  .footer-comfirm {
    border-radius: 2px;
    height: 32px !important;
    color: #fff;
    background: #00a497;
  }
  .footer-cancles {
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    // margin-top: 12px;
    // margin-right: 24px;
    background: #fafafa;
  }
  .footer-cancle {
    // margin-top: 12px;
    margin-right: 24px;
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    background: #fafafa;
  }
}
/deep/.ant-modal-content {
  width: 436px;
  height: 197px;
}
</style>
